import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-bundle-carousel',
  templateUrl: './bundle-carousel.component.html',
  styleUrls: ['./bundle-carousel.component.scss']
})
export class BundleCarouselComponent {
  @Input() bundles: any[] = [];
  @Input() country: string = '';
  @Input() useIvan: boolean = false;
  @Input() storeIsItunes: boolean = false;

  @Output() onClick = new EventEmitter<{ event: any, bundle: any }>();

  currentIndex = 0;

  get canPrev() { return this.currentIndex > 0; }
  get canNext() { return this.currentIndex < this.bundles.length - 1; }

  prev() { if (this.canPrev) this.currentIndex--; }
  next() { if (this.canNext) this.currentIndex++; }
  goTo(index: number) { if (index >= 0 && index < this.bundles.length) this.currentIndex = index; }

  handleClick(event: any, bundle: any) {
    this.onClick.emit({ event, bundle });
  }
}
